import React from "react";
import { Flex } from "rebass/styled-components";

import { layout } from "../constants/constants";
import DynamicButton, { mediumNavListButtonSettings, smallNavListButtonSettings } from "../shared/components/dynamic-button/dynamic-button";
import SocialMediaButtons from "../shared/components/social-media-buttons/social-media-buttons";
import {
  FooterColumnContent,
  FooterLinkContent,
  GlobalFlatFooterContent,
  IconPack,
  SocialMediaLinkContent
} from "../shared/models/app-data-model";
import GlobalFlatFooterColumn from "./global-flat-footer-column/global-flat-footer-column";
import "./global-flat-footer.scss";

export type GlobalFlatFooterProps = {
  content: GlobalFlatFooterContent;
  title: string;
  copyrightSubtext?: string;
  iconPack: IconPack[];
};

const GlobalFlatFooter: React.FC<GlobalFlatFooterProps> = ({ content, copyrightSubtext, title, iconPack }: GlobalFlatFooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="global-flat-footer">
        <Flex className="footer-container">
          <Flex className="footer-top" width={layout.pageWidth} px={layout.pagePaddingX} mx="auto" flexWrap="wrap">
            {content?.footer_content?.map((item, index) => {
              return <GlobalFlatFooterColumn content={item?.column as FooterColumnContent} iconPack={iconPack} key={index} />;
            })}
          </Flex>
          <Flex className="footer-bottom" flexWrap="wrap">
            <Flex className="sub-footer-bottom-section" width={layout.pageWidth} px={layout.pagePaddingX} mx="auto" flexDirection="column">
              <div className="policies-container">
                <div className="policies-heading">{content?.footer_policies_and_links?.[0]?.heading?.heading}</div>
                <div className="policies-links">
                  {content?.footer_policies_and_links && (
                    <ul className="footer-links-list">
                      {content?.footer_policies_and_links?.[1]?.link_list?.links?.map((link: FooterLinkContent, index) => {
                        return (
                          <>
                            {link?.display_text && link?.reference && (
                              <li className="policies-languages-list-item" data-testid="dynamic-btn-test">
                                <DynamicButton
                                  content={{
                                    text: `${link?.display_text}`,
                                    icon: `${link?.new_window_icon ? "new_window" : "none"}`,
                                    reference: link?.reference,
                                    settings: smallNavListButtonSettings
                                  }}
                                  iconPack={iconPack}
                                  key={index}
                                />
                              </li>
                            )}
                          </>
                        );
                      })}
                    </ul>
                  )}
                </div>
              </div>
              <div className="languages-container">
                <div className="languages-heading">{content?.footer_language_links?.[0]?.heading?.heading}</div>
                <div className="languages-links">
                  {content?.footer_policies_and_links && (
                    <ul className="footer-links-list">
                      {content?.footer_language_links?.[1]?.link_list?.links?.map((link: FooterLinkContent, index) => {
                        return (
                          <>
                            {link?.display_text && link?.reference && (
                              <li className="policies-languages-list-item" data-testid="dynamic-btn-test">
                                <DynamicButton
                                  content={{
                                    text: `${link?.display_text}`,
                                    icon: `${link?.new_window_icon ? "new_window" : "none"}`,
                                    reference: link?.reference,
                                    settings: smallNavListButtonSettings
                                  }}
                                  iconPack={iconPack}
                                  key={index}
                                />
                              </li>
                            )}
                          </>
                        );
                      })}
                    </ul>
                  )}
                </div>
              </div>
            </Flex>
            <Flex className="divider-container" width={layout.pageWidth} px={layout.pagePaddingX} mx="auto">
              <Flex className="footer-divider"></Flex>
            </Flex>
            <Flex
              className="sub-footer-top-section"
              width={layout.pageWidth}
              px={layout.pagePaddingX}
              mx="auto"
              flexDirection="column"
              alignItems="center"
            >
              {content?.social_media_links && (
                <Flex className="social-media-links">
                  <SocialMediaButtons socials={content.social_media_links as SocialMediaLinkContent[]} />
                </Flex>
              )}
              <div className="footer-copyright">
                &copy; {currentYear} {title}
                <br />
                {copyrightSubtext && <span>{copyrightSubtext}</span>}
              </div>
            </Flex>
          </Flex>
        </Flex>
      </footer>
    </>
  );
};

export default GlobalFlatFooter;
